import {useState, useEffect} from "react";
import {Head, useRouter} from "../../../components/atoms/DependencyHelper";
import ClickAndCollectModal from "../../../components/molecules/modals/clickAndCollectModal/ClickAndCollectModal";
import ProductDetailsBody from "../../../components/vaimo/productDetailsBody/ProductDetailsBody";
import {ProductDetails} from "../../../config/queries";
import ajaxService from "../../../utils/ajaxServices";
import * as Analytics from "../../../services/analyticsUtag";
import dynamic from "next/dynamic";
import labels from "../../../config/labels";
import PageError from "../../../components/molecules/pageError/pageError";
import {
  dynamicBreadCrumb,
  getAmountOffValue,
  hideSpinner,
  showSpinner,
  updateBreadCrumbPageTitle,
  options,
  configurableOptions,
  isArrayNotEmpty,
  setCookieConsentWrapper,
  getCookieValue,
  clearUserToken,
} from "../../../utils/helperServices";
import handleGeoLocation, {getNearestStore} from "../../../utils/handleGeoLocation";
import {connect} from "react-redux";
import config from "../../../config/index";
import {setProfileData} from "../../../Redux/actions/navAction";
import {resetSyncUserProfile} from "../../../Redux/actions/userProfileAction";
import ErrorTooltip from "../../../components/molecules/errorToolTip/ErrorTooltip";
import {setGeoLocationStatus, setGeoLocationPosition} from "../../../Redux/actions/geoLocationAction";
import types from "../../../config/types";
import {setHelpLeadBucket} from "../../../Redux/actions/getHelpAction";
import {LEAD_BUCKETS} from "../../../config/constants";

const ProductDetailsHeader = dynamic(
  import(
    "../../../components/vaimo/ProductDetailsHeader/ProductDetailsHeader"
    ),
  {ssr: false}
);
const ProductDetailsFooterTop = dynamic(
  import(
    "../../../components/organisms/productDetailsFooterTop/ProductDetailsFooterTop"
    ),
  {ssr: false}
);
const PropTypes = dynamic(import("prop-types"), {ssr: false});

const ProductDetailsPage = (props) => {
  const [selectedVariant, setSelectedVariant] = useState(null);
  const [defaultVariant, setDafaultVariant] = useState(true);
  const [selectedBuyOptionType, setSelectedBuyOptionType] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const [analytics, setAnalytics] = useState(false);
  const [productDetails, setProductDetails] = useState(null);
  const [showError, setShowError] = useState(false);
  const [optList, setOptList] = useState([]);
  const router = useRouter();
  const { query } = router;
  const env = config.env;
  const imagePrefix = config.envConfigs[env].imagePrefix;
  const shoppingUrlPrefix = config.envConfigs[env].shoppingUrlPrefix;
  const [refreshUser, setRefreshUser] = useState(false);
  const [isUserProfileSync, setIsUserProfileSync] = useState();
  const [isModalOpen, setShowModal] = useState(false);
  const [showSnackBar, setShowSnackBar] = useState({
    visible: false,
    message: "",
  });
  const loginUrl = config.envConfigs[env].DIDLoginUrl;
  const [redirectURL, setRedirectURL] = useState("");
  const [upgradeChecksEnabled, setUpgradeChecksEnabled] = useState(true);
  const [isClickndCollectFeatureEnabled, setIsClickndCollectFeatureEnabled] = useState(true);
  const [storeAddress, populateStoreList] = useState([]);
  const [nearestStore, setNearestStore] = useState(undefined);
  const [serviceDown, setServiceDown] = useState(true);

  async function featuresCheck() {
    try {
      const featuresResult = await ajaxService.httpGet(
        "featureBaseUrl",
        "",
        "api",
        "features",
      );
      setUpgradeChecksEnabled(featuresResult?.upgradeChecksEnabled || false);
      setIsClickndCollectFeatureEnabled(featuresResult?.clickAndCollect || false);
    } catch (e) {
      console.log("deal-details: features : error: ", e)
    }
  }

  useEffect(() => {
    async function fetchData() {
      window.productCalled = true;
      setShowError(false);
      showSpinner();
      const result = await ajaxService.fetchGraphQLPOSTRequest(
        ProductDetails,
        {
          id: query && query.id ? query.id.toString() : "",
        },
        "",
        true
      );
      if (
        result &&
        result.products &&
        result.products.items &&
        result.products.items.length
      ) {
        window.productCalled = false;
        setProductDetails(result.products.items[0]);
        setLoaded(false);
        setAnalytics(false);
      } else {
        setShowError(true);
        setProductDetails(result.products?.items[0]);
        Analytics.link({
          page_name: "shopping: devices: product details",
          page_form_event: "error",
          page_errors: `${labels.lbl_menu_top.lbl_product_404_heading}. ${labels.lbl_menu_top.lbl_product_404_description}`,
          page_errors_code: `pdp-m-p-pd-${result?.status}`,
        });
        window.productCalled = false;
      }
      if (result && result.errors) {
        window.productCalled = false;
        Analytics.link({
          page_name: "shopping: devices: product details",
          page_form_event: "error",
          page_errors: `${result.errors?.[0] ? result.errors?.[0]?.message : ""}`,
          page_errors_code: `pdp-m-p-pd-${result?.status}`,
        });
      }
      window.scrollTo(0, 0);
      hideSpinner();
    }

    setIsUserProfileSync();
    props?.resetSyncUserProfile();
    setRefreshUser(false);
    closeSnackBar();

    if (!window.productCalled) {
      fetchData();
    }
  }, [query?.id]);

  useEffect(() => {
    if (productDetails) {
      setSelectedVariant(productDetails?.variants?.[0]);
      const list = [];
      if (
        productDetails?.__typename === labels.lbl_product_typeName_configurable
      ) {
        const optionsList = configurableOptions(
          productDetails?.configurable_options
        );

        const filteredVariants = [];
        const isStockList = [];

        productDetails?.variants?.forEach((variant) => {
          filteredVariants.push(variant.product);
        });
        filteredVariants.map((stock) => {
          isStockList.push(stock.stock_status)
        })

        optionsList.forEach((option) => {
          const opt = options(productDetails?.configurable_options, option);
          let some = {};

          some[option] = opt;
          list.push(some);
        });

        setOptList(list);
      }
    }

  }, [productDetails]);

  useEffect(() => {
    // fetch user location for store stock check
    if (isClickndCollectFeatureEnabled) {
      if (productDetails &&
        productDetails?.badges_label != types.TYPE_PREORDER) {
        getUserLocation(productDetails.sku);
      }
    }
  }, [productDetails, isClickndCollectFeatureEnabled]);

  let productName, category, categoryId, buyOptionType;

  if (
    productDetails &&
    Object.prototype.hasOwnProperty.call(productDetails, "name")
  ) {
    productName = productDetails.name;
  }

  if (
    productDetails &&
    productDetails.categories &&
    productDetails.categories.length > 0
  ) {
    category = productDetails.categories[0].name;
    categoryId = productDetails.categories[0].id;
  }

  const getFinalPrice = (priceRange) => {
    return priceRange.maximum_price.final_price.value;
  };

  const updateBuyOptionType = (buyOption) => {
    buyOptionType = buyOption;
    setSelectedBuyOptionType(buyOptionType);
  };

  const updateSelectedVariant = (variant) => {
    setSelectedVariant(variant);
    setDafaultVariant(false);
  };
  const dynamicRoute = dynamicBreadCrumb();
  useEffect(() => {
    const pages = Object.keys(dynamicRoute);
    if (!loaded && pages.length && productDetails) {
      let flag = null;
      if (
        productDetails?.__typename === labels.lbl_product_typeName_configurable
      ) {
        var maxQuantity = productDetails?.variants.reduce(function (prev, current) {
          if (+current.product?.quantity > +prev.product?.quantity) {
            return current;
          } else {
            return prev;
          }
        });
        if (maxQuantity !== null) {
          flag = maxQuantity?.product?.badges_label
        } else {
          flag = productDetails?.badges_label
        }
      } else {
        flag = productDetails?.badges_label
      }
      setLoaded(true);
      if (productDetails) {
        if (!analytics) {
          const userMetaData = Analytics.getProfileData(
            props.userLoggedIn,
            props.profileData
          );
          const analyticsData = {
            page_event: "view",
            page_name: "shopping: devices: product details",
            page_channel: "shopping",
            page_master_tab: "personal",
            sales_event: "view",
            sales_order_discount: [getAmountOffValue(productDetails)],
            sales_product_category: [category?.toString()],
            sales_product_id: [productDetails?.name?.toString()],
            sales_product_price: [
              getFinalPrice(productDetails?.price_range).toString(),
            ],
            sales_product_quantity: [1],
            sales_promo_name: flag,
            page_hierarchy: "shopping: browse all product: product details",
            page_site_section_lvl_1: productDetails?.name?.toString(),
            page_site_section_lvl_2: `Browse products`,
            page_site_section_lvl_3: `Home`,
            ...userMetaData,
          };
          if (productDetails?.badges_label) {
            analyticsData.sales_promo_name = [
              productDetails?.badges_label,
            ];
          }
          if (productDetails?.badges_label == types.TYPE_PREORDER) {
            analyticsData.preorder_flag = "true";
          }
          if (productDetails?.stock_status?.toLowerCase() === "out_of_stock") {
            analyticsData.page_tool_event = "use";
            analyticsData.page_tool_name =
              "shopping: devices: product details: out of stock";
          }
          analyticsData.out_of_stock =
            productDetails?.stock_status?.toLowerCase();
          Analytics.view(analyticsData);
          setAnalytics(true);
        }
      }
    }
  }, [dynamicRoute, productDetails]);

  useEffect(() => {
    featuresCheck();
    props?.setHelpLeadBucket(LEAD_BUCKETS.general);

    Analytics.setAutoTagging(false);
    if (typeof window !== undefined) {
      setRedirectURL(window.location.href);
    }
    setIsUserProfileSync();
    props?.resetSyncUserProfile();
    setRefreshUser(false);
    closeSnackBar();
    updateBreadCrumbPageTitle(router.pathname, productName);
  }, []);

  const getUserLocation = (productSKU) => {
    handleGeoLocation(props, productSKU, populateStoreList, setServiceDown);
  }

  useEffect(() => {
    if (storeAddress && storeAddress.length) {
      const storeDetails = getNearestStore(storeAddress);
      setNearestStore(storeDetails);
    }
  }, [storeAddress]);

  const showModal = () => {
    setShowModal(true);
  };

  const hideModal = () => {
    setShowModal(false);
  };

  const getCustomDropDown = () => {
    if (productDetails && productDetails?.options?.length) {
      const customDropDown = productDetails.options.filter(
        (option) => option["__typename"] === labels.lbl_custom_dropdown_typeName
      );
      return customDropDown.length ? customDropDown[0] : [];
    }
  };

  const getSortedOptions = (optionsArr) => {
    if (isArrayNotEmpty(optionsArr)) {
      const once_off = optionsArr.find(
        (option) => option?.sku === labels.lbl_custom_dropdown_prepaid_option
      );
      const contract = optionsArr.find(
        (option) => option?.sku === labels.lbl_custom_dropdown_deal_option
      );
      const upgrade = optionsArr.find(
        (option) => option?.sku === labels.lbl_custom_dropdown_upgrade_option
      );

      return [contract, upgrade, once_off];
    }
  };

  const goToProducts = () => {
    Analytics.link({
      page_name: "shopping: devices: product details",
      link_type: "o",
      link_name:
        "shopping: devices: product details: error Browse all products",
    });
    showSpinner();
    router.push(`${shoppingUrlPrefix}/products`).then(() => {
      hideSpinner();
    });
  };

  useEffect(() => {
    if (
      props?.userProfileSync?.userDetails &&
      props?.userProfileSync?.userDetails != null
    ) {
      setIsUserProfileSync();

      const {apiStatus} = props?.userProfileSync?.userDetails;
      if (apiStatus && !refreshUser) {
        const cartId = getCookieValue("cart_id");
        updateCookieConsentWrapper(props?.userProfileSync?.userDetails, cartId);
        setRefreshUser(true);
      } else {
        hideSpinner();
        props?.resetSyncUserProfile();
        setRefreshUser(false);
        if (props?.userProfileSync?.userDetails?.apiFailStatus == "401") {
          clearUserToken();
          setTimeout(() => {
            window.location.replace(loginUrl + "?redirectUrl=" + redirectURL);
          }, 100);
          return;
        } else {
          displaySnakbar();
        }
      }
    }
    // return () => {
    //   if (props?.userProfileSync?.userDetails) {
    //     hideSpinner();
    //   }
    // };
  }, [props?.userProfileSync]);

  const displaySnakbar = () => {
    setShowSnackBar({
      visible: true,
      message: labels.errorMessages.lbl_user_profile_sync,
    });
  };

  const closeSnackBar = () => {
    setShowSnackBar({visible: false, message: ""});
  };

  const updateCookieConsentWrapper = (profileInfo, cartId) => {
    try {
      let oAuthToken =
        profileInfo?.result?.magentoProfileResponse[0]?.OAuthTokenDetails[0]
          ?.OAuthToken;
      cartId = profileInfo?.result?.magentoProfileResponse[0]?.mergedCartID;
      setCookieConsentWrapper(
        "auth_token",
        [config.cookie_category.strictly_necessary],
        `document.cookie='auth_token=${oAuthToken};path=/'`
      );
      setCookieConsentWrapper(
        "cart_id",
        [config.cookie_category.strictly_necessary],
        `document.cookie='cart_id=${cartId};path=/'`
      );
    } catch (error) {
      console.log("");
    } finally {
      const updatedProfileInfo = profileInfo?.result;
      setRefreshUser(false);
      hideSpinner();
      if (updatedProfileInfo) {
        props?.setProfileData(profileInfo);
        props?.resetSyncUserProfile();
        // handleAddToCart();
        setIsUserProfileSync(profileInfo?.pageAction);
      } else {
        props?.resetSyncUserProfile();
      }
    }
  };
  const isEligible = () => {
    return props?.upgrade?.upgradeCheckDone && props?.upgrade?.selectedUpgradeResponse?.upgradeEligible && props?.upgrade?.topBannerVisible;
  }

  const selectedStoreDetails = (selectedStore) => {
    if (selectedStore) {
      setNearestStore(selectedStore);
    }
    hideModal();
  }

  useEffect(() =>
  {
    document.body.classList.add("product-details");
  }, []);

  return (
    <div className="product-details-page">
      <div className="product-details-page-inner">
        {showSnackBar.visible && (
          <ErrorTooltip
            className="error-container"
            errorMsg={showSnackBar.message}
            buttonHandler={closeSnackBar}
          />
        )}
        {productDetails && (
          <>
            <ClickAndCollectModal
              sku={productDetails.sku}
              isModalOpen={isModalOpen}
              hideModal={hideModal}
              storeAddress={storeAddress}
              geoLocationIsAllowed={props.geoLocation?.allowed}
              selectedStore={selectedStoreDetails}
            />
            <Head>
              <title>{productName}</title>
            </Head>
            <ProductDetailsHeader
              productName={productName}
              rating={3.2}
              brand={
                productDetails && productDetails.manufacturer_label
                  ? productDetails.manufacturer_label
                  : ""
              }
              category={category}
              brandId={
                productDetails && productDetails.manufacturer
                  ? productDetails.manufacturer
                  : ""
              }
              categoryId={categoryId}
              promotionTag={productDetails && productDetails?.badges_label == types.TYPE_PREORDER
                ? productDetails?.badges_label
                : ""
              }
            />
            <ProductDetailsBody
              getVariant={(selectedVariant) =>
                updateSelectedVariant(selectedVariant)
              }
              productDetails={productDetails}
              selectedVariant={selectedVariant}
              buyOptions={
                getCustomDropDown()?.value?.length &&
                getSortedOptions(getCustomDropDown()?.value)
              }
              buyOptionTitle={getCustomDropDown()?.title}
              getBuyOptionType={(optionType) => {
                updateBuyOptionType(optionType);
              }}
              buyOptionId={getCustomDropDown()?.option_id}
              optList={optList}
              triggerCallback={isUserProfileSync}
              showSnackBarEvent={displaySnakbar}
              closeSnackBarEvent={closeSnackBar}
              upgradeChecksEnabled={upgradeChecksEnabled}
              isEligible={isEligible()}
              showModal={showModal}
              geoLocationIsAllowed={props.geoLocation?.allowed}
              nearestStore={nearestStore}
              isStoreStockServiceDown={serviceDown}
              brand={
                productDetails && productDetails.manufacturer_label
                  ? productDetails.manufacturer_label
                  : ""
              }
              category={category}
              brandId={
                productDetails && productDetails.manufacturer
                  ? productDetails.manufacturer
                  : ""
              }
            />
          </>
        )}
        {showError && (
          <PageError
            className="not-found"
            heading={labels.lbl_menu_top.lbl_product_404_heading}
            description={labels.lbl_menu_top.lbl_product_404_description}
            primaryLabel="Browse all products"
            handlePrimaryClick={goToProducts}
            imgUrl={`${imagePrefix}/assets/images/search-not-found.svg`}
          />
        )}
      </div>
      {productDetails && (
        <ProductDetailsFooterTop
          defaultVariant={defaultVariant}
          selectedVariant={selectedVariant}
          productDetails={productDetails}
          sku={productDetails?.sku}
          selectedBuyOptionType={selectedBuyOptionType}
          buyOptionId={getCustomDropDown()?.option_id}
          buyOptionTypeId={
            getSortedOptions(getCustomDropDown()?.value)?.[0]?.option_type_id
          }
          triggerCallback={isUserProfileSync}
          showSnackBarEvent={displaySnakbar}
          closeSnackBarEvent={closeSnackBar}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  profileData: state.navDetails.profileData,
  userLoggedIn: state.navDetails.isUserLoggedIn,
  userProfileSync: state.userProfileSync,
  upgrade: state.upgrade,
  geoLocation: state.geoLocation,
});

ProductDetailsPage.defaultProps = {
  //productsByBrandId: null,
};

ProductDetailsPage.propTypes = {
  profileData: PropTypes.object,
  userLoggedIn: PropTypes.bool,
  resetSyncUserProfile: PropTypes.func,
  setProfileData: PropTypes.func,
  userProfileSync: PropTypes.any,
  upgrade: PropTypes.object,
  setHelpLeadBucket: PropTypes.func,
  geoLocation: PropTypes.object
};

export default connect(mapStateToProps, {
  resetSyncUserProfile,
  setProfileData,
  setGeoLocationStatus,
  setGeoLocationPosition,
  setHelpLeadBucket
})(ProductDetailsPage);
